import PlayerConstants from "../../../shared/constants/player";
import storageConstants from "../../../shared/constants/storage";
import { setLocalStorage, removeLocalStorage } from "../../../shared/utils/localStorage";
import { removeSessionStorage, setSessionStorage } from "../../../shared/utils/sessionStorage";
import { ANALYTICS_STORAGE_KEYS, LINK_INFO } from "../../../shared/constants/analytics";
import { trackPlayerMute } from "../../../shared/analytics/media";
import { showOrHideFullScreen, isFullScreen } from "../../../shared/utils/playerUtils";
const { PLAYER_CONTROLS } = PlayerConstants;
const { VOD, RECORDING } = PlayerConstants.PLAYER_TYPE;

const { USER_HAS_CLICK, IS_FRESH_LOGIN, PLAYER_LOADED } = storageConstants;

export const handleVideoControlsMouseMove = (
  setVideoControlsStyle,
  videoControlsTimer,
  setVolumeVisibility,
  setSettingsDropdownVisibility,
  videoWrapper
) => {
  setVideoControlsStyle({ opacity: 0.9, visibility: "visible" });

  if (videoControlsTimer && videoControlsTimer.current) clearTimeout(videoControlsTimer.current);

  videoControlsTimer.current = setTimeout(() => {
    setVolumeVisibility(false);
    setSettingsDropdownVisibility(false);
    videoWrapper.current && videoWrapper.current.focus();
    setVideoControlsStyle({ opacity: 0, visibility: "hidden" });
  }, 5000);
};

export const handleClickToggleState = (
  event,
  type,
  isTimeShiftAllowed,
  spinnerToggle,
  playPauseButtonHandler,
  onFullScreenButtonHandler,
  signalUserActivity
) => {
  const className = event.target.className;

  if (
    className.includes("playbackControl-top") ||
    className.includes("info") ||
    className.includes("playbackControl-metaData") ||
    className.includes("playbackControl-bottom") ||
    className.includes("videoControls")
  ) {
    if (event.detail === 1) {
      if ((type === VOD || type === RECORDING || isTimeShiftAllowed) && !spinnerToggle) playPauseButtonHandler(event);
    } else if (event.detail === 2) {
      onFullScreenButtonHandler(event);
      if ((type === VOD || type === RECORDING || isTimeShiftAllowed) && !spinnerToggle) playPauseButtonHandler(event);
    }
  }
  signalUserActivity();
};

export const handleVideoControlsKeyUp = (
  event,
  spinnerToggle,
  showNextEpisodeCard,
  showStillWatchingPrompt,
  videoControlsMouseMove,
  isOnDemandType,
  isTimeShiftAllowed,
  isRWEnabled,
  setVolumeVisibility,
  rewindButtonHandler,
  isFFEnabled,
  isStartOverAllowed,
  isRestartedStream,
  forwardButtonHandler,
  playPauseButtonHandler
) => {
  if (!spinnerToggle && !showNextEpisodeCard && !showStillWatchingPrompt) {
    videoControlsMouseMove();
    if (isOnDemandType || isTimeShiftAllowed) {
      switch (event.keyCode) {
        case 37:
          if (isRWEnabled || isTimeShiftAllowed) {
            setVolumeVisibility(false);
            rewindButtonHandler(event);
          }
          break;
        case 39:
          if (isFFEnabled || isTimeShiftAllowed || (isStartOverAllowed && isRestartedStream)) {
            setVolumeVisibility(false);
            forwardButtonHandler(event);
          }
          break;
        case 32:
          event.preventDefault();
          playPauseButtonHandler(event);
          break;
        default:
          break;
      }
    }
  }
};

export const handleVolumeKeyUp = (
  event,
  showNextEpisodeCard,
  showStillWatchingPrompt,
  videoControlsMouseMove,
  volumeBarRef,
  setVolumeVisibility,
  settingsDropdownVisibility,
  setSettingsDropdownVisibility,
  onFullScreenButtonHandler,
  volumeButtonHandler
) => {
  if (!showNextEpisodeCard && !showStillWatchingPrompt) {
    videoControlsMouseMove();
    switch (event.keyCode) {
      case 38:
      case 40:
        if (volumeBarRef.current) volumeBarRef.current.focus();
        setVolumeVisibility(true);
        if (settingsDropdownVisibility) setSettingsDropdownVisibility(false);
        break;
      case 70:
        onFullScreenButtonHandler(event);
        break;
      case 77:
        volumeButtonHandler(event);
        break;
      default:
        break;
    }
  }
};

export const focusVideoWrapper = (videoWrapper) => {
  if (videoWrapper.current) {
    videoWrapper.current.focus();
  }
};

export const handleRewindButton = (
  videoWrapper,
  toggleSpinningLoader,
  playerLoaderClassName,
  seekPlayback,
  signalUserActivity
) => {
  focusVideoWrapper(videoWrapper);
  toggleSpinningLoader(true, playerLoaderClassName);
  seekPlayback(-10);
  signalUserActivity();
};

export const handleRestartedStreamForwardButton = (
  videoWrapper,
  isRestartTrickPlayAllowed,
  displayToastNotification,
  toggleSpinningLoader,
  playerLoaderClassName,
  seekPlayback,
  signalUserActivity
) => {
  focusVideoWrapper(videoWrapper);
  if (!isRestartTrickPlayAllowed.current) {
    displayToastNotification("message_fast_forward_disabled");
  } else {
    toggleSpinningLoader(true, playerLoaderClassName);
    seekPlayback(30);
  }
  signalUserActivity();
};

export const handleForwardButton = (
  videoWrapper,
  toggleSpinningLoader,
  playerLoaderClassName,
  seekPlayback,
  signalUserActivity,
  isVOD
) => {
  focusVideoWrapper(videoWrapper);
  toggleSpinningLoader(true, playerLoaderClassName);
  seekPlayback(isVOD ? 10 : 30);
  signalUserActivity();
};

export const handleVolumeButtonHover = (setSettingsDropdownVisibility, setVolumeVisibility, volumeBarRef) => {
  setSettingsDropdownVisibility(false);
  setVolumeVisibility(true);
  if (volumeBarRef.current) {
    volumeBarRef.current.focus();
  }
};

export const handleVolumeSlideChange = (input, setVolumeLevel, setIsMuted, signalUserActivity) => {
  input = parseInt(input);
  setLocalStorage(PLAYER_CONTROLS.MUTE, "false");
  setLocalStorage(PLAYER_CONTROLS.VOLUME, input);
  setVolumeLevel(input);
  setIsMuted(false);
  if (input === 0) {
    setIsMuted(true);
    setLocalStorage(PLAYER_CONTROLS.MUTE, "true");
    setLocalStorage(PLAYER_CONTROLS.VOLUME, 10);
  }
  signalUserActivity();
};

export const toggleSettingVisibility = (
  setVolumeVisibility,
  setSettingsDropdownVisibility,
  settingsDropdownVisibility,
  signalUserActivity
) => {
  setVolumeVisibility(false);
  setSettingsDropdownVisibility(!settingsDropdownVisibility);
  signalUserActivity();
};

export const handleVolumeToggle = (
  userHasClick,
  setUserHasClick,
  setSettingsDropdownVisibility,
  setVolumeVisibility,
  event,
  isMuted,
  setVolume,
  playerMgr,
  setVolumeLevel,
  initialVolume,
  setIsMuted,
  signalUserActivity
) => {
  if (!userHasClick) {
    setSessionStorage(USER_HAS_CLICK, true);
    setUserHasClick(true);
  }

  setSettingsDropdownVisibility(false);
  setVolumeVisibility(true);
  event.stopPropagation();

  if (!isMuted) {
    setVolume(playerMgr, 0);
    setVolumeLevel(0);
    setLocalStorage(PLAYER_CONTROLS.MUTE, "true");
    trackPlayerMute(true);
  } else {
    setLocalStorage(PLAYER_CONTROLS.MUTE, "false");
    let prevVol = initialVolume;
    let currVol = prevVol ? prevVol : 100;
    setVolume(playerMgr, currVol);
    setVolumeLevel(currVol);
    trackPlayerMute(false);
  }

  setIsMuted(!isMuted);
  signalUserActivity();
};

export const handleClosePlayer = (
  isClosingPlayer,
  isFreshLogin,
  playerLoaded,
  isNotStillWatching,
  hasCalledStopContent,
  handleAVSStopContent,
  history
) => {
  handleAVSStopContent();
  isClosingPlayer.current = true;
  if (isFreshLogin) removeLocalStorage(IS_FRESH_LOGIN);
  if (playerLoaded) removeSessionStorage(PLAYER_LOADED);

  if (!isNotStillWatching) {
    setSessionStorage(ANALYTICS_STORAGE_KEYS.LINK, `${LINK_INFO.CLOSE};${LINK_INFO.PLAYER}`);
  }
  if (hasCalledStopContent.current) hasCalledStopContent.current = false;
  if (1 < history.length) {
    history.goBack();
  } else {
    history.push("/");
  }
};

export const handleFullScreenToggle = (onFullScreenClick, document, videoWrapper, signalUserActivity) => {
  if (onFullScreenClick) {
    onFullScreenClick(isFullScreen(document));
  }
  showOrHideFullScreen(isFullScreen(document), document, videoWrapper.current);
  signalUserActivity();
};
